module.exports = __webpack_public_path__ + "img/geofisica_4-3_682.a5cd0d14.webp";